import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { BuilderReference, BuilderReferenceRequest } from '../models/builder-reference.models';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

@Injectable({
  providedIn: 'root'
})
export class BuilderReferenceService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;
  #builderReferences$?: Observable<BuilderReference[]>;

  getBuilderReferences(): Observable<BuilderReference[]> {
    this.#builderReferences$ ??= this.#http
      .getData(`${this.baseUrl}/BuilderReference`, { showLoader: false, showMessage: false })
      .pipe(
        tap({ error: () => (this.#builderReferences$ = undefined) }),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    return this.#builderReferences$;
  }

  getBuilderReferenceById(id: string): Observable<BuilderReference> {
    return this.#http.getData(`${this.baseUrl}/BuilderReference/${id}`, { showLoader: true, showMessage: false });
  }

  createBuilderReference(reference: string): Observable<BuilderReference> {
    return this.#http
      .postData(`${this.baseUrl}/BuilderReference`, { showLoader: true, showMessage: true }, reference)
      .pipe(tap(() => (this.#builderReferences$ = undefined)));
  }

  updateBuilderReference(reference: BuilderReferenceRequest): Observable<BuilderReference> {
    return this.#http
      .putData(`${this.baseUrl}/BuilderReference/${reference.id}`, reference, {
        showLoader: true,
        showMessage: true
      })
      .pipe(tap(() => (this.#builderReferences$ = undefined)));
  }

  deleteBuilderReference(id: string): Observable<BuilderReference[]> {
    return this.#http
      .deleteData(`${this.baseUrl}/BuilderReference/${id}`, { showLoader: true, showMessage: true })
      .pipe(tap(() => (this.#builderReferences$ = undefined)));
  }
}
